export default import.meta.ROLLDOWN_FILE_URL_L0$LEAet5b27A8y$$nPHHw